import { useGqlQuery } from '@API/useAvQuery';
import { AsyncGetOptions } from '@components/Table/types';
import useQueryObjectSql from './useQueryObjectSql';
import useQuerySql from './useQuerySql';

export const useAsyncFilterOptions = ({
  options,
  isEnabled,
  placeholderData,
}: {
  options?: ReturnType<AsyncGetOptions>;
  isEnabled: boolean;
  placeholderData?: <T>(previousData: T | undefined) => T | undefined;
}) => {
  const { type, ...hookOptions } = options || {};

  const { data: gqlData, isLoading: gqlIsLoading } = useGqlQuery({
    ...(hookOptions as any),
    enabled: isEnabled && (type === 'gql' || type === 'gqlPagination'),
    placeholderData,
  });

  const {
    data: sqlData,
    isLoading: sqlIsLoading,
    totals: sqlTotals,
  } = useQuerySql({
    ...(hookOptions as any),
    options: {
      enabled: isEnabled && type === 'sql',
      placeholderData,
    },
  });

  const {
    data: queryObjectData,
    isLoading: queryObjectIsLoading,
    totalRowCount: queryObjectTotalRowCount,
  } = useQueryObjectSql({
    ...(hookOptions as any),
    options: {
      enabled: isEnabled && type === 'queryObject',
      placeholderData,
    },
  });

  if (type === 'gql') {
    return { data: gqlData, isLoading: gqlIsLoading, totalRowCount: undefined };
  }

  if (type === 'gqlPagination') {
    const { data = undefined, totals = undefined } = (gqlData || {}) as any;
    return { data, isLoading: gqlIsLoading, totalRowCount: totals };
  }
  if (type === 'sql') {
    return { data: sqlData, isLoading: sqlIsLoading, totalRowCount: sqlTotals };
  }
  if (type === 'queryObject') {
    return { data: queryObjectData, isLoading: queryObjectIsLoading, totalRowCount: queryObjectTotalRowCount };
  }

  return { data: undefined, isLoading: false, totalRowCount: undefined };
};
